<template>
  <div v-if="show" class="toolbar-general">
    <div v-if="transparentToolbar" class="opacity-div"/>
    <v-app-bar id="toolbar" class="Toolbar white px-0" app>
      <div class="transparent-div" v-if="dialMenu"/>
      <v-speed-dial
        v-model="dialMenu"
        direction="bottom"
        class="speed-dial"
        transition="slide-y-transition"
      >
        <template v-slot:activator>
          <v-btn
            v-model="dialMenu"
            color="black"
            small
            fab
            text
            :class="`ma-0 my-3 ${dialMenu ? 'dial-menu-btn-active' : ''}`"
            id="btnDialMenu"
            @click="toggleMenu(dialMenu)"
          >
            <v-icon v-if="dialMenu">close</v-icon>
            <v-icon v-else>menu</v-icon>
          </v-btn>
        </template>

        <v-row v-if="isUserAuthToCrud" class="mt-1 speed-dial-elem-row" no-gutters>
          <v-col class="align-self-center">
            <v-btn
              class="ml-0"
              fab
              small
              activeClass="menuLink"
              @click="clickOrganizationHomeBtn"
            >
              <v-icon>dashboard</v-icon>
            </v-btn>
          </v-col>
          <v-col class="align-self-center">
            <div class="px-4 py-3 speed-dialog-label-div" @click="clickOrganizationHomeBtn">
              <p class="mb-0">{{ $t('Toolbar.dashboard') }}</p>
            </div>
          </v-col>
        </v-row>

        <v-row v-if="isUserAuthToReports" class="mt-1 speed-dial-elem-row" no-gutters>
          <v-col class="align-self-center">
            <v-btn
              class="ml-0"
              fab
              small
              activeClass="menuLink"
              @click="clickReportsBtn"
            >
              <v-icon>analytics</v-icon>
            </v-btn>
          </v-col>
          <v-col class="align-self-center">
            <div class="px-4 py-3 speed-dialog-label-div" @click="clickReportsBtn">
              <p class="mb-0">{{ $t('Toolbar.reports') }}</p>
            </div>
          </v-col>
        </v-row>

        <v-row v-if="isUserAuthToAudits" class="mt-1 speed-dial-elem-row" no-gutters>
          <v-col class="align-self-center">
            <v-btn
              class="ml-0"
              fab
              small
              activeClass="menuLink"
              @click="clickAuditsBtn"
            >
              <v-icon>mdi-clipboard-check-outline</v-icon>
            </v-btn>
          </v-col>
          <v-col class="align-self-center">
            <div class="px-4 py-3 speed-dialog-label-div" @click="clickAuditsBtn">
              <p class="mb-0">{{ $t('Toolbar.audits') }}</p>
            </div>
          </v-col>
        </v-row>
      </v-speed-dial>
      <v-avatar size="40">
        <img
          :src="require('../../assets/logoPonce.png')"
          :alt="$t('Toolbar.profilePic')"
          class="fill-height"
        />
      </v-avatar>

      <v-spacer />

      <ImpersonateBtn />
      <v-menu bottom left offset-y>
        <template v-slot:activator="{on}">
          <v-btn
            v-model="dialMenu"
            small
            fab
            text
            class="BtnAccount ma-0 my-3"
            v-on="on"
          >
            <v-avatar size="40">
              <img
                :src="userProfilePic"
                class="profile-img"
              />
            </v-avatar>
          </v-btn>
        </template>

        <v-list class="pa-0">
          <v-list-item
            @click="onLogout()"
          >
            <v-list-item-title>{{$t('Toolbar.logout')}}</v-list-item-title>
          </v-list-item>
        </v-list>
      </v-menu>
    </v-app-bar>
  </div>
</template>


<script>
import {isAuthToEdit, isAuthToReports, isAuthToAudits} from '../../lib/helpers'
import { isToolbarVisibleForRoute } from '../../lib/toolbarVisibility'
import ImpersonateBtn from './ImpersonateBtn.vue'
import { trackEvent } from '../../lib/track-events'
import { EVENTS_TO_TRACK  } from '../../constants/const'

export default {
  data () {
    return {
      transparentToolbar: false,
      transparentToolbarRoutes: ['/addDevice', '/addUser', '/addCrop'],
      show: false,
      searchText: '',
      dialMenu: false
    }
  },
  created () {
    this.show = this.setShow()
  },
  components: {
    ImpersonateBtn
  },
  methods: {
    setShow () {
      return isToolbarVisibleForRoute(this.$router.currentRoute)
    },
    onLogout () {
      this.$store.dispatch('logout')
      this.$router.push('/signin')
    },
    toggleMenu (isMenuOpened) {
      if (isMenuOpened) {
        trackEvent(EVENTS_TO_TRACK.CLICK_CLOSE_MENU_BUTTON)
      } else {
        trackEvent(EVENTS_TO_TRACK.CLICK_OPEN_MENU_BUTTON)
      }
    },
    clickOrganizationHomeBtn () {
      trackEvent(EVENTS_TO_TRACK.CLICK_ORGANIZATION_HOME_VIEW_BUTTON)
      this.$router.push('/organizationHome')
    },
    clickReportsBtn () {
      trackEvent(EVENTS_TO_TRACK.CLICK_REPORTS_VIEW_BUTTON)
      this.$router.push('/reports')
    },
    clickAuditsBtn () {
      trackEvent(EVENTS_TO_TRACK.CLICK_AUDITS_VIEW_BUTTON)
      this.$router.push('/audits')
    }
  },
  computed: {
    userProfilePic () {
      if (this.$store.getters.user && this.$store.getters.user.photoUrl) {
        return this.$store.getters.user.profilePic
      }
      if (this.$store.getters.user.roles) {
        if (this.$store.getters.user.isAdmin || this.$store.getters.user.roles.owner) {
          return require('../../assets/owner.png')
        } else if (this.$store.getters.user.roles.manager) {
          return require('../../assets/manager.png')
        } else if (this.$store.getters.user.roles.fieldman) {
          return require('../../assets/fieldman.png')
        } else if (this.$store.getters.user.roles.farmhand) {
          return require('../../assets/farmhand.png')
        }
      }
      return require('../../assets/farmhand.png')
    },
    isUserAuthToCrud () {
      const user = this.$store.getters.user
      return isAuthToEdit(user, this.$store.getters.impersonatedUserId)
    },
    isUserAuthToReports () {
      const user = this.$store.getters.user
      return isAuthToReports(user, this.$store.getters.impersonatedUserId)
    },
    isUserAuthToAudits () {
      const user = this.$store.getters.user
      return isAuthToAudits(user, this.$store.getters.impersonatedUserId)
    }
  },
  watch: {
    '$route' (to) {
      this.show = isToolbarVisibleForRoute(to)
      if (this.transparentToolbarRoutes.includes(to.fullPath)) {
        this.transparentToolbar = true
      } else {
        this.transparentToolbar = false
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// Toolbar.vue?052a8c93